/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ToolsInputs */

const en_nav_tools = /** @type {(inputs: Nav_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tools`)
};

const de_nav_tools = /** @type {(inputs: Nav_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tools`)
};

const fr_nav_tools = /** @type {(inputs: Nav_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outils`)
};

const es_nav_tools = /** @type {(inputs: Nav_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas`)
};

const it_nav_tools = /** @type {(inputs: Nav_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti`)
};

const nl_nav_tools = /** @type {(inputs: Nav_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gereedschappen`)
};

const pl_nav_tools = /** @type {(inputs: Nav_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narzędzia`)
};

const fi_nav_tools = /** @type {(inputs: Nav_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työkalut`)
};

const da_nav_tools = /** @type {(inputs: Nav_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Værktøjer`)
};

const sv_nav_tools = /** @type {(inputs: Nav_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verktyg`)
};

/**
* | output |
* | --- |
* | "Tools" |
*
* @param {Nav_ToolsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_tools = /** @type {((inputs?: Nav_ToolsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ToolsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_tools(inputs)
	if (locale === "fr") return fr_nav_tools(inputs)
	if (locale === "es") return es_nav_tools(inputs)
	if (locale === "it") return it_nav_tools(inputs)
	if (locale === "nl") return nl_nav_tools(inputs)
	if (locale === "pl") return pl_nav_tools(inputs)
	if (locale === "fi") return fi_nav_tools(inputs)
	if (locale === "da") return da_nav_tools(inputs)
	if (locale === "sv") return sv_nav_tools(inputs)
	return en_nav_tools(inputs)
});